import React from 'react';
import cn from 'classnames';
import styles from './Error.module.scss';

const Error = ({ error, fullScreen }) => {
  if (!Boolean(error)) {
    return null;
  }

  return (
    <p
      className={cn(styles.root, {
        [styles.fullScreen]: fullScreen,
      })}
    >
      {error}
    </p>
  );
};

export default Error;
